import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import WithProviders from "./WithProviders";

import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <WithProviders>
      <App />
    </WithProviders>
  </React.StrictMode>
);
